import update from 'immutability-helper';
import boardEntriesActions from '../actions/boardEntriesActions';

const boardEntriesReducer = (state = [], action) => {
  const itemIndex = state.findIndex((item) => item.id === action?.payload?.id);

  switch (action.type) {
    case boardEntriesActions.constants.set:
      return action.payload;

    case boardEntriesActions.constants.add:
      return update(state, { $push: [action.payload] });

    case boardEntriesActions.constants.update:
      return update(state, {
        [itemIndex]: { $merge: action.payload },
      });

    case boardEntriesActions.constants.remove:
      return update(state, { $splice: [[itemIndex, 1]] });

    default:
      return state;
  }
};

export default boardEntriesReducer;
